import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import axios from "axios";
import configData from "../config.json";

function ForgotPassword(props) {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    gsap.to('#core', { backgroundColor: '#eee', duration: 0.3 });
    props.menuColor('none');
    props.accentColor('#FFFFFF');
    props.logoColor('fillBlack');
    document.title = "Reset Password | " + configData.BASE_TITLE;
    document.querySelector('meta[name="description"]').setAttribute("content", "");
    document.documentElement.scrollTop = 0;
  }, []);

  function handleSubmit() {
    if (!email) return;
    setLoading(true);
    setError(null);

    axios({
      method: 'post',
      baseURL: configData.API_URL,
      url: '/auth/users/reset_password/',
      data: { email: email }
    })
      .then(() => {
        setSubmitted(true);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        // Djoser returns 204 even for non-existent emails (by design),
        // so errors here are typically network issues
        setError("Something went wrong. Please try again.");
      });
  }

  function handleKeyUp(e) {
    if (e.key === "Enter") {
      handleSubmit();
    }
  }

  if (submitted) {
    return (
      <section className="main pageItem-enter-active" id="loginFormPage">
        <div className="loginForm">
          <h1>Check Your Email</h1>
          <p className="resetMessage">
            If an account exists with that email address, we've sent password reset instructions.
          </p>
          <div className="formField">
            <Link to="/signin/" className="btn1 submitBtn resetLink">Back to Sign In</Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="main pageItem-enter-active" id="loginFormPage" onKeyUp={handleKeyUp}>
      <div className="loginForm">
        <h1>Reset Password</h1>
        <p className="resetMessage">
          Enter the email address associated with your account and we'll send you a link to reset your password.
        </p>
        <div className="formField">
          <input
            autoComplete="off"
            type="email"
            name="email"
            id="email"
            required
            placeholder="email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        {error && <p className="resetError">{error}</p>}
        <div className="formField">
          <input
            type="submit"
            className="btn1 submitBtn"
            value={loading ? "Sending..." : "Send Reset Link"}
            onClick={handleSubmit}
            disabled={loading}
          />
        </div>
        <div className="formField resetBackLink">
          <Link to="/signin/">Back to Sign In</Link>
        </div>
      </div>
    </section>
  );
}

export default ForgotPassword;
